import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import { MutableState, Tools } from 'final-form'
import { Segment, Form } from 'semantic-ui-react'

import { getDiff, getFormValidate } from '../../../../../../utils/form'

import {
  PersonFormatted,
  personToExternal
} from '../../../../utils/formatPerson'

import { usePerson } from '../../hooks'
import { personSchema } from './schemas'
import { FormActions, AddressFields, PersonFields } from './components'

const defaultInitialValues = {
  type: 'COMPANY',
  active: true
}

const validateForm = getFormValidate(personSchema)

type SetFieldValuesMutator = (
  args: any[],
  state: MutableState<PersonFormatted>,
  tools: Tools<PersonFormatted>
) => void

interface PersonMainProps {
  initialValues?: Partial<PersonFormatted>
  onSubmit?: (values: PersonFormatted) => void
}

export const PersonMain: React.FC<PersonMainProps> = ({
  initialValues = {},
  onSubmit: onParentSubmit
}) => {
  const { person: currentPerson, createPerson, updatePerson } = usePerson()

  function handleSubmit(values: PersonFormatted) {
    const data = personToExternal(values)

    if (!currentPerson) {
      createPerson(data)
      onParentSubmit?.(values)
      return
    }

    const diff = getDiff(currentPerson, values)

    if (!diff || Object.keys(diff).length === 0) {
      return
    }

    updatePerson(data)
    onParentSubmit?.(values)
  }

  const setFieldValues: SetFieldValuesMutator = (
    args,
    state,
    { changeValue }
  ) => {
    const [data] = args
    Object.keys(data).forEach(key => {
      changeValue(state, key, () => data[key])
    })
  }

  return (
    <FinalForm<PersonFormatted>
      onSubmit={handleSubmit}
      initialValues={
        {
          ...defaultInitialValues,
          ...initialValues,
          ...currentPerson
        } as Partial<PersonFormatted>
      }
      key={currentPerson?.id || 'new'}
      validate={validateForm}
      validateOnBlur
      mutators={{ setFieldValues }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormActions />
          <Segment>
            <PersonFields />
            <AddressFields />
          </Segment>
        </Form>
      )}
    </FinalForm>
  )
}
